import Naver, { EfProductNaverProps, EfProductNaverItemProps } from '@elem/ui/ef-product-naver';
import { useState } from 'react';
import Overview from './tabs/Overview';
import { theme } from './config/page';
import Support from './tabs/Support';
import Spec from './tabs/Spec';
import css from './index.module.scss';
import getProductMsg from './context/getProduct';
import { useProduct } from './ProductProvider';
import { useLang } from '@/i18n';

const StreamUltraX: React.FC = () => {
    const { state, dispatch } = useProduct();
    // console.log('state', state);
    const { t } = useLang('stream_ultra_x');
    const { productMsg, productSupport, productSpecs, activeTab } = state;
    const [activetedTabs, setActivetedTabs] = useState<string[]>([activeTab]);

    const naverProps: EfProductNaverProps = {
        theme: 'black',
        title: productMsg?.name || t('naver_title'),
        tabs: [
            {
                key: 'Product',
                text: t('naver_tab_product'),
            },
            {
                key: 'Spec',
                text: t('naver_tab_spec'),
            },
            {
                key: 'Support',
                text: t('naver_tab_support'),
            },
        ],
        buyItem: {
            key: 'Bundle',
            text: t('naver_tab_buy'),
        },
        activeTab,
        buyNowGtm: {
            event: 'uaEvent',
            event_name: 'click_anchor',
            position: t('C_tab1'),
            button_name: t('naver_tab_buy'),
        },
        callbackBuy: () => {
            if (activeTab !== 'Product') {
                dispatch({
                    type: 'changeProductTab',
                    payload: 'Product',
                });
            }
            setTimeout(() => {
                const streamUltraXC = document.getElementById('stream-ultra-x-C') as HTMLElement;
                if (streamUltraXC) {
                    streamUltraXC.scrollIntoView({
                        behavior: 'smooth',
                    });
                }
            }, 200);
        },
        callbackTab: (tab: EfProductNaverItemProps) => {
            if (tab.key !== activeTab) {
                if (!activetedTabs.includes(tab.key)) {
                    setActivetedTabs([...activetedTabs, tab.key]);
                }
                dispatch({
                    type: 'changeProductTab',
                    payload: tab.key,
                });
            }
        },
    };

    return (
        <>
            {!productMsg && getProductMsg()}
            <div className={`stream-ultra-x ${css.section}`} style={{ minHeight: '100vh' }}>
                <Naver {...naverProps} />
                {activetedTabs.includes('Product') && (
                    <div className="page-tab tab-overview" style={{ display: activeTab === 'Product' ? 'block' : 'none' }}>
                        <Overview />
                    </div>
                )}
                {activetedTabs.includes('Spec') && (
                    <div className="page-tab tab-Spec" style={{ display: activeTab === 'Spec' ? 'block' : 'none' }}>
                        <Spec productSpecs={productSpecs} theme={theme} title={t('naver_tab_spec')} />
                    </div>
                )}
                {activetedTabs.includes('Support') && (
                    <div className="page-tab tab-support" style={{ display: activeTab === 'Support' ? 'block' : 'none' }}>
                        <Support supportData={productSupport} productMsg={productMsg} theme={theme} />
                    </div>
                )}
            </div>
        </>
    );
};

export default StreamUltraX;
